module.exports = __webpack_public_path__ + "assets/img/2026-meeting-reconvented-after.f7a9ecca.jpg";